// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__k3q59","head":"ProcedureTableInfo_head__6l63W"};